import ChunkedPaginationUtils from '../../../global/chunkedPaginationUtils.js';

export const pagedPeople = new ChunkedPaginationUtils();

export const DEFAULT_STATE = {
    activeLoadMore: true,
    canLoadMore: false,
    isFetching: false,
    isFetchingCoreMilestonesByPersonIds: false,
    coreMilestonesByPersonIds: [],
    needsToRequest: false,
    pageNumber: 0,
    pageSize: pagedPeople.getPageSize(),
    people: [],
    total: 0,
};

export default (state = DEFAULT_STATE, action) => {
    const {
        callbackParams,
        result: actionResult,
        type: actionType,
    } = action;

    switch (actionType) {
        case 'PeopleSearchActions.ON_BEFORE__GETPEOPLE': {
            return {
                ...state,
                isFetching: true,
            };
        }

        case 'PeopleSearchActions.ON__GETPEOPLE': {
            pagedPeople.loadPage(
                actionResult.results,
                actionResult.resultCount,
                callbackParams.first,
            );

            // Fall through to next page case
        }

        /* eslint-disable no-fallthrough */
        case 'PeopleSearchActions.ON_GET_PEOPLE_NEXT_PAGE': {
            return {
                ...state,
                people: pagedPeople.getAll(true),
                isFetching: false,
                canLoadMore: pagedPeople.canLoadMore(),
                needsToRequest: pagedPeople.needsToLoadPage(),
                pageNumber: pagedPeople.getCurrentPageNumber(),
                pageSize: pagedPeople.getPageSize(),
                total: pagedPeople.getTotalCount(),
            };
        }
        /* eslint-enable no-fallthrough */

        case 'PeopleSearchActions.ON_BEFORE_GETCOREMILESTONESBYPERSONIDS': {
            return {
                ...state,
                isFetchingCoreMilestonesByPersonIds: true,
            };
        }

        case 'PeopleSearchActions.ON_GETCOREMILESTONESBYPERSONIDS': {
            return {
                ...state,
                isFetchingCoreMilestonesByPersonIds: false,
                coreMilestonesByPersonIds: [
                    ...state.coreMilestonesByPersonIds,
                    ...action.result,
                ],
            };
        }

        case 'PeopleSearchActions.ON_RESET_CORE_MILESTONES_BY_PERSON_IDS': {
            return {
                ...state,
                isFetchingCoreMilestonesByPersonIds: false,
                coreMilestonesByPersonIds: DEFAULT_STATE.coreMilestonesByPersonIds,
            };
        }

        case 'PeopleSearchActions.ON_RESET_PEOPLE': {
            return DEFAULT_STATE;
        }

        case 'PeopleSearchActions.ON_TOGGLE_ACTIVE_LOAD_MORE': {
            return { ...state, activeLoadMore: action.isActiveLoadMore };
        }

        default:
            return state;
    }
};
